import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import {inspection as endpoint} from '@/configs/endpoints'
const store = 'measurementBrake'

export default {
  state: () => ({
    isLoad: false,
    typesMeasurement: [
      { id: 1, name: 'Вимірювання робочої гальмівної системи (РГС)'},
      { id: 0, name: 'Вимірювання стояночної гальмівної системи (СГС)'}
    ],
    measurementInformation: {}
  }),
  actions: {
    async setInformationForBrakeMeasurementStands (context, data) {
      const response = await api.post(endpoint.brakeMeasurementStands(data.params), {body: data.body})
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'measurementInformation', data: response.data })
        return response
      }
    },
    async getInformationForBrakeMeasurementStands (context, data) {
      const response = await api.get(endpoint.brakeMeasurementStands(data.params))
      if (await requestValidation(response)) {
        let axis_results = []
        if (response.data?.axis_results) {
          for (let axis in response.data.axis_results.main) {
            axis_results.push(
              {
                ...response.data.axis_results.main[axis],
                axis_id: +axis,
                brake_system_type: 1
              }
            )
          }
          for (let axis in response.data.axis_results.park) {
            axis_results.push(
              {
                ...response.data.axis_results.park[axis],
                axis_id: +response.data.axis_results.park[axis].axis,
                brake_system_type: 0
              }
            )
          }
        }
        axis_results.forEach(axis => {
          const duplicatedAxes = axis_results.filter(item => item.axis_id === axis.axis_id)
          if (duplicatedAxes.length > 1) {
            axis_results = axis_results.filter(item => item.axis_id !== axis.axis_id)
            axis_results.push({
              axis_id: axis.axis_id,
              duplicatedAxes: duplicatedAxes
            })
          }
        })

        context.commit('SET_DATA', { store, state: 'measurementInformation', data: { ...response.data, axis_results} })
        return response.data
      }
    },
    async updateInformationForBrakeMeasurementStands (context, data) {
      const response = await api.patch(endpoint.brakeMeasurementStands(data.params), {body: data.body})
      if (await requestValidation(response)) {
        await context.dispatch('getInformationForBrakeMeasurementStands', data)
        return response
      }
    },

    async setInformationZigBeeEquipmentForBrakeMeasurement (context, data) {
      const response = await api.post(endpoint.zigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        await context.dispatch('getInformationForBrakeMeasurementZigBeeEquipment', data)
        return response
      } else {
        return false
      }
    },
    async updateInformationZigBeeEquipmentForBrakeMeasurement (context, data) {
      const response = await api.patch(endpoint.zigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        await context.dispatch('getInformationForBrakeMeasurementZigBeeEquipment', data)
        return response
      } else {
        return false
      }
    },
    async getInformationForBrakeMeasurementZigBeeEquipment (context, data) {
      const response = await api.get(endpoint.zigBeeEquipment(data.params))
      if (await requestValidation(response)) {
        let axis_results = []

        if (response.data?.axis_results.main && Object.keys(response.data?.axis_results.main).length) {
          for (let axis in response.data.axis_results.main) {
            axis_results.push(
              {
                ...response.data.axis_results.main[axis],
                axis_id: +axis,
                brake_system_type: 1,
                one_wheel_axis: response.data.axis_results.main[axis].one_wheel_axis
              }
            )
          }
        }
        if (response.data?.axis_results.park && Object.keys(response.data?.axis_results.park).length) {
          for (let axis in response.data.axis_results.park) {
            axis_results.push(
              {
                ...response.data.axis_results.park[axis],
                axis_id: +axis,
                brake_system_type: 0,
                one_wheel_axis: response.data.axis_results.park[axis].one_wheel_axis
              }
            )
          }
        }
        axis_results.forEach(axis => {
          const duplicatedAxes = axis_results.filter(item => item.axis_id === axis.axis_id)
          if (duplicatedAxes.length > 1) {
            axis_results = axis_results.filter(item => item.axis_id !== axis.axis_id)
            axis_results.push({
              axis_id: axis.axis_id,
              duplicatedAxes: duplicatedAxes
            })
          }
        })

        context.commit('SET_DATA', { store, state: 'measurementInformation', data: { ...response.data, axis_results} })
        return response.data
      }
    }
  }
}
